// extracted by mini-css-extract-plugin
export default {"MainCont":"Mixing_MainCont__bsIz7","LeftCont":"Mixing_LeftCont__pCgYo","RightCont":"Mixing_RightCont__nAFHl"};